import React, { useState, useContext } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import DesktopLayout from '../layouts/DesktopLayout';
import MessageQueueTab from '../components/messaging/MessageQueueTab';
import TemplatesTab from '../components/messaging/TemplatesTab';
import SettingsTab from '../components/messaging/SettingsTab';
import GeneralGuestGuideTab from '../components/messaging/GeneralGuestGuideTab';
import useLanguage from '../hooks/useLanguage';
import { AuthContext } from '../context/AuthContext';

const MessagingAutomationPage = () => {
  const [activeNavItem, setActiveNavItem] = useState('messaging-automation');
  const [activeTab, setActiveTab] = useState('queue');
  const { user } = useContext(AuthContext);
  const { t } = useLanguage();

  const isAdmin = user?.role === 'admin';

  return (
    <DesktopLayout
      activeNavItem={activeNavItem}
      setActiveNavItem={setActiveNavItem}
      headerTitle="أتمتة الرسائل"
    >
      <Container fluid className="p-4" dir="rtl">
        {/* Page Header */}
        <div className="mb-4">
          <h2 className="text-dark fw-bold mb-2">أتمتة الرسائل</h2>
          <p className="text-muted mb-0">
            إدارة الرسائل التلقائية عبر واتساب و SMS
          </p>
        </div>

        {/* Tabs */}
        <Tabs
          id="messaging-automation-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-4"
          dir="rtl"
        >
          {/* Tab 1: Message Queue */}
          <Tab eventKey="queue" title="قائمة الرسائل" dir="rtl">
            <MessageQueueTab />
          </Tab>

          {/* Tab 2: Templates */}
          <Tab eventKey="templates" title="القوالب" dir="rtl">
            <TemplatesTab />
          </Tab>

          {/* Company-wide guest-guide content (tasks/guest-guide-sections-and-print-sheet.md G12).
              The page guard already limits this page to admin + ops-manager; the server enforces
              the same on save. */}
          <Tab eventKey="guestGuide" title={t('guestGuide.general.tabTitle')} dir="rtl">
            <GeneralGuestGuideTab />
          </Tab>

          {/* Tab 3: Settings (Admin Only) */}
          {isAdmin && (
            <Tab eventKey="settings" title="الإعدادات" dir="rtl">
              <SettingsTab />
            </Tab>
          )}
        </Tabs>
      </Container>
    </DesktopLayout>
  );
};

export default MessagingAutomationPage;
